import { UploadFile } from "antd";
import { S3FileType } from "interfaces";
import { operations } from "types/openapi";

type uploadDocOperation = operations["uploadDoc"]["parameters"]["query"];

export const filesToFormData = (files: UploadFile[], fileType: S3FileType): uploadDocOperation => {
  const formData = new FormData();
  files.forEach((file) => {
    if (file.originFileObj) {
      formData.append("files", file.originFileObj);
    }
  });

  formData.append("type", fileType);

  return formData as unknown as uploadDocOperation;
};

export const filesToFormDataSingle = (files: UploadFile[], fileType: S3FileType): uploadDocOperation => {
  const formData = new FormData();

  formData.append("file", files[0]?.originFileObj as File);

  formData.append("type", fileType);

  return formData as unknown as uploadDocOperation;
};
